// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_ResponsiveRecommendation.scss
// module id = 653
// module chunks = 22 88